import { datadogRum } from "@datadog/browser-rum";

type DatadogRumUser = {
  accountEmail: string;
  accountName?: string;
};

export const setDatadogRumUser = ({
  accountEmail,
  accountName,
}: DatadogRumUser) => {
  datadogRum.setUser({
    id: accountEmail,
    email: accountEmail,
    name: accountName,
    userEmail: accountEmail,
  });
};

export const clearDatadogRumUser = () => {
  datadogRum.clearUser();
};
